// Port of HanDu/DesignSystem/AnimatedAuthBackground.swift — the signed-out
// screen's backdrop, "warm vermilion and gold blooms drifting slowly across
// the app's background, like ink diffusing in water."
//
// The four blobs sit at the mesh's four interior control points and carry the
// saturated colour, which is why they're the ones worth moving. See
// handu.css for the orbit mechanism and the pinned outer ring.

// Periods are co-prime-ish (13 / 9 / 16 / 11 s) so the combined figure takes
// minutes to repeat and never reads as a loop. Phases are the Swift view's
// radian offsets converted to a negative animation-delay: a delay of
// -(phase / 2pi) * period starts the orbit already that far round.
const BLOBS = [
  // (1/3, 1/3) — primaryContainer, the strongest bloom.
  { top: '33.33%', left: '33.33%', period: '13s', phase: '0s', tint: 'rgba(192, 57, 43, 0.52)', size: 'clamp(360px, 48vw, 820px)' },
  // (2/3, 1/3) — gold.
  { top: '33.33%', left: '66.67%', period: '9s', phase: '-3.44s', tint: 'rgba(201, 162, 39, 0.40)', size: 'clamp(320px, 42vw, 720px)' },
  // (1/3, 2/3) — gold, the quieter of the two.
  { top: '66.67%', left: '33.33%', period: '16s', phase: '-10.44s', tint: 'rgba(201, 162, 39, 0.34)', size: 'clamp(320px, 44vw, 760px)' },
  // (2/3, 2/3) — primary.
  { top: '66.67%', left: '66.67%', period: '11s', phase: '-2.1s', tint: 'rgba(158, 32, 22, 0.44)', size: 'clamp(340px, 46vw, 780px)' },
]

// Unit space in the app maps to the full screen, where the orbit radius is
// 0.15. Clamped here so it stays a visible drift on a phone and doesn't swing
// halfway across a wide desktop viewport.
const RADIUS = 'clamp(70px, 12vw, 210px)'

export default function AuthGradient() {
  return (
    <div className="handu-gradient" aria-hidden="true">
      {BLOBS.map((blob) => (
        <div
          key={`${blob.top}-${blob.left}`}
          className="handu-orbit"
          style={{
            top: blob.top,
            left: blob.left,
            '--period': blob.period,
            '--phase': blob.phase,
          }}
        >
          <div
            className="handu-blob"
            style={{ '--tint': blob.tint, '--size': blob.size, '--radius': RADIUS }}
          />
        </div>
      ))}
    </div>
  )
}
